import React, { useReducer, useEffect, useState } from "react";
import { initialState, reducer } from "../../hooks/modalReducer";
import { Row, Col, Form } from "antd";
import {
  Grid,
  BreadCrumbBox,
  Typography,
  Section,
  Button,
  CollapsPanel,
  Modal,
  Loading,
} from "../../core";
import Svg from "../../assets/icons/icon";
import { HistoryOutlined } from "@ant-design/icons";
import { media, MixStyle } from "../../styles";
import LetterHead from "../../components/LetterHead";
import styled from "styled-components";
import Steps from "../../components/Steps";
import DispatchHistory from "../../components/DispatchHistory";
import OtherBills from "../../components/OtherBills";
import AddPayment from "../../components/AddPayment";
import AddPaymentHistory from "../../components/AddPaymentHistory";
import InvoiceHistory from "../../components/InvoiceHistory";
import { useParams } from "react-router-dom";
import { getInvoiceById } from "../../helper/utils/api/invoice";
import { getDispatchesOfContract } from "../../helper/utils/api/dispatch";
import { mapInvoiceForList } from "../../helper/utils/invoiceMap";
const btnTypoProps = {
  as: "span",
  fontSize: "24px",
  weight: "600",
};
const Container = styled.div`
  .p-md-20 {
    ${media.minitablet`padding: 50px 20px;`}
  }
`;
const TotalBillContainer = styled.div`
  max-width: 570px;
  margin: 20px auto;
  .b-b-2 {
    border-bottom: 2px solid #e7ecf4;
  }
  .f-between {
    ${MixStyle.flexBetween};
  }
  > div {
    padding: 15px 0px;
    > span {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      color: #404e67;
    }
  }
  .footer--div {
    ${MixStyle.flexArround};
    background: #eff5fe;
    border-radius: 0px 0px 14px 14px;
  }
`;
const ActionContainer = styled.div`
  max-width: 380px;
  ${MixStyle.flexBetween};
  ${media.mobile`display:block;`}
`;
const InvoiceInner = () => {
  const { invoiceId } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [dispatchRows, setDispatchRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!invoiceId) return;
      setIsLoading(true);
      try {
        const { data } = await getInvoiceById(invoiceId);
        const inv = mapInvoiceForList(data?.result || data);
        setInvoice(inv);
        if (inv.contract_id || inv.contractId) {
          const dispRes = await getDispatchesOfContract({
            contractId: inv.contract_id || inv.contractId,
            limit: 100,
          });
          const dispList = dispRes.data?.result || dispRes.data || [];
          const rows = (Array.isArray(dispList) ? dispList : []).map((d, i) => ({
            key: d._id || d.dispatch_id || i,
            SNo: String(i + 1),
            data: d.dateDispatch || d.date_dispatch || "",
            quality: d.clothQuality || d.cloth_quality || "",
            godown: d.godown || "",
            Lshort: d.lShort || d.l_short || "",
            kslip: d.kPatchParchiNumber || d.k_patch_parchi_no || "",
            rejection: d.glrReceived || d.glr_received || "",
            rejDate: d.clothReturnDate || d.date_cloth_return || "",
            pslip: d.packiParchiNumber || d.p_patch_parchi_no || "",
            invoiceStatus: d.invoiceStatus || d.invoice_status || "pending",
          }));
          setDispatchRows(rows);
        }
      } catch (error) {
        console.log("invoice inner error", error);
      }
      setIsLoading(false);
    };
    load();
  }, [invoiceId]);

  const otherBills = invoice
    ? [
        {
          description: invoice.invoice_note || "Invoice total",
          ammount: invoice.total_value_include_sale_tax || 0,
        },
      ]
    : [];

  if (isLoading) return <Loading />;
  if (!invoice && invoiceId) {
    return (
      <Grid>
        <BreadCrumbBox tittle="Contract Invoice" />
        <Section padding="20px">
          <Typography text="Invoice not found" as="h3" />
        </Section>
      </Grid>
    );
  }

  return (
    <Grid>
      <Container>
        <BreadCrumbBox tittle="Contract Invoice" />
        <Steps
          createInvoice={<div>creteInvoice</div>}
          sendInvocie={<div>sendInvocie</div>}
          getinvoice={<GetInvoiceRow />}
        />
        <LetterHead className="p-md-20">
          <DispatchHistory data={dispatchRows} />
          <div className="mt-20">
            <OtherBills otherBills={otherBills} />
          </div>
          <div className="mt-20">
            <Typography as="h3" weight="bold" color="#233B67">
              Note :
            </Typography>
            <Section bg="#F3F3F3" radius="15px" padding="20px 50px">
              <Typography as="h6" color="#979BA4" weight="500">
                {invoice?.invoice_note || "No note"}
              </Typography>
            </Section>
          </div>
          <TotalBillContainer>
            <div className="f-between b-b-2">
              <Typography as="h3" noMargin color="#233B67" weight="bold">
                Sub Total :
              </Typography>
              <Typography as="h3" noMargin color="#404E67" weight="500">
                {invoice?.total_price_without_sale_tax || 0}
              </Typography>
            </div>
            <div className="f-between b-b-2">
              <span>Tax : </span>
              <span>{invoice?.total_sale_tax_payable || 0}</span>
            </div>
            <div className="footer--div">
              <Typography as="h3" noMargin color="#404E67" weight="500">
                Total
              </Typography>
              <Typography as="h3" noMargin color="#404E67" weight="500">
                Rs
                <span className="themed--color_pink">
                  {invoice?.total_value_include_sale_tax || 0}
                </span>
              </Typography>
            </div>
          </TotalBillContainer>
          <ActionContainer>
            <Button margin="10px auto" width="115px" bg="#D7E1EB">
              <Typography {...btnTypoProps} color="#586E86" text="Edit" />
            </Button>
            <Button
              margin="10px auto"
              width="115px"
              bg="white"
              border="2px solid #FF5687"
            >
              <Typography {...btnTypoProps} color="#FF5687" text="Export" />
            </Button>
            <Button margin="10px auto" width="115px" bg="#FF5687">
              <Typography {...btnTypoProps} color="white" text="Print" />
            </Button>
          </ActionContainer>
        </LetterHead>
        <div className="mt-20">
          <Row type="flex" justify="space-between" gutter={[16, 16]}>
            <Col lg={12} xs={24}>
              <CollapsPanel
                header={{ tittle: "History", icon: <HistoryOutlined /> }}
              >
                <InvoiceHistory />
              </CollapsPanel>
            </Col>
            <Col lg={12} xs={24}>
              <CollapsPanel
                header={{
                  tittle: "Payment",
                  icon: (
                    <Svg
                      width={59}
                      height={39}
                      className="mr-20"
                      color="#233B67"
                      icon="money"
                    />
                  ),
                }}
              >
                <AddPaymentHistory />
              </CollapsPanel>
            </Col>
          </Row>
        </div>
      </Container>
    </Grid>
  );
};
const GetInvoiceRow = () => {
  const [form] = Form.useForm();
  const [state, dispatch] = useReducer(reducer, initialState);
  const btnProps = {
    margin: "10px 10px",
    width: "102px",
    height: "21px",
  };
  const typoProps = {
    as: "span",
    fontSize: "14px",
    lineHeight: "21px",
  };
  const modalProps = {
    btnTypoProps: {
      as: "h5",
      align: "center",
      weight: "bold",
      color: "white",
    },
  };
  function clickHandler(params) {
    dispatch({
      type: "MODAL_VIEW",
      payload: { flag: true, modal_name: params },
    });
  }
  function onCreate(values) {
    dispatch({ type: "MODAL_VIEW", payload: false });
  }
  function oK() {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        onCreate(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  }
  return (
    <div className="d-flex f-wrap">
      <Button
        bg="#D7E1EB"
        {...btnProps}
        onClick={() => clickHandler("marksAsPaid")}
      >
        <Typography {...typoProps} color="#3D5166">
          Mark As Paid
        </Typography>
      </Button>
      <Button
        bg="#8FD1A8"
        {...btnProps}
        onClick={() => clickHandler("add_payment")}
      >
        <Typography {...typoProps} color="white">
          Add Payment
        </Typography>
      </Button>
      {state.modal_name === "add_payment" ? (
        <Modal
          closable={false}
          visible={state.visible}
          onCreate={onCreate}
          okText="Add"
          onOk={oK}
          onCancel={() => {
            dispatch({ type: "MODAL_VIEW", payload: false });
          }}
          tittle="Add Payment"
        >
          <AddPayment form={form} />
        </Modal>
      ) : state.modal_name === "marksAsPaid" ? (
        <Modal
          closable={false}
          visible={state.visible}
          footer={false}
          maxwidth="500px"
          onCancel={() => {
            dispatch({ type: "MODAL_VIEW", payload: false });
          }}
          tittle="Are you sure you want to mark as paid this Invoice ?"
        >
          <Row tyep="flex" justify="space-between">
            <Button bg="#233B67" width="100px">
              <Typography noMargin {...modalProps.btnTypoProps} text="Yes" />
            </Button>
            <Button bg="#233B67" width="100px">
              <Typography noMargin {...modalProps.btnTypoProps} text="No" />
            </Button>
          </Row>
        </Modal>
      ) : null}
    </div>
  );
};
export default InvoiceInner;
